import React, { useState } from 'react';
import { useViewlogies } from 'context';

const Step1 = ({ onNext, color }) => {
    const {
        event: { firstName, lastName },
    } = useViewlogies();

    const [checked, setChecked] = useState([false, false, false]);

    const allChecked = checked.every(Boolean);

    const toggle = index => {
        const next = [...checked];
        next[index] = !next[index];
        setChecked(next);
    };

    return (
        <>
            <h2 className="registration-title">
                Welcome to the memorial service for {firstName} {lastName}
            </h2>
            <p className="registration-subtitle">to view the service, please acknowledge:</p>

            <div className="registration-acknowledgements">
                <label className="registration-acknowledgement-item">
                    <input type="checkbox" checked={checked[0]} onChange={() => toggle(0)} />
                    <span>
                        {firstName} {lastName}'s service is a private event by invitation only.
                    </span>
                </label>
                <label className="registration-acknowledgement-item">
                    <input type="checkbox" checked={checked[1]} onChange={() => toggle(1)} />
                    <span>Content is created by the family for non-commercial use to memorialize their loved one.</span>
                </label>
                <label className="registration-acknowledgement-item">
                    <input type="checkbox" checked={checked[2]} onChange={() => toggle(2)} />
                    <span>
                        By entering this site, you agree to Viewlogies{' '}
                        <a href="https://www.viewlogies.com/terms" target="_blank" rel="noreferrer">
                            Terms of Service
                        </a>{' '}
                        and{' '}
                        <a href="https://www.viewlogies.com/privacy" target="_blank" rel="noreferrer">
                            Privacy Policy
                        </a>
                    </span>
                </label>
            </div>

            <button
                className="registration-primary-btn"
                style={{ backgroundColor: color }}
                onClick={onNext}
                type="button"
                disabled={!allChecked}
            >
                Enter Site
            </button>
        </>
    );
};

export default Step1;
